<template lang="pug">
  div( class='listing-favorites__container' :class='{visible : visible}')
    h2 Favorites
    div( v-if='favoriteListings.length == 0')
      p You haven't added any favorite listings yet.
    ul
      li( v-for="favorite in favoriteListings")
        img( :src='favorite.Photos ? favorite.Photos[0] : require("../assets/uprightlogo.png")' ,  @click="$emit('update:active-listing', {listing:favorite, listings:favoriteListings})" ) 
        span( @click="$emit('update:active-listing', {listing:favorite, listings:favoriteListings})" ) {{getAddressString(favorite)}}
        i( class='el-icon-error' @click="removeFavorite(favorite)")
    el-button(
      class='listing-favorites__expand-button' 
      type='warning' 
      @click='visible = !visible' 
      icon="el-icon-star-on" 
    )
</template>

<script>
import { mapState } from 'vuex'

export default {
  data(){
    return{
      visible: false
    }
  },
  computed: {
    ...mapState([
      'favoriteListings'
    ])
  },
  methods: {
    getAddressString(listing){
      return listing
        ? [
            listing.StreetNumber, listing.StreetName//, 
            //listing.Unit ? "#"+ listing.Unit : ""
          ].join(" ")
        : "";
    },
    removeFavorite(listing){
      this.$store.commit("listingRemoveFavorite", listing);
    }
  }
}
</script>

<style lang="scss" scoped>
//@import '../_variables';

span{
  flex-grow: 1;
  font-size: 1.1em;
  margin-left: 5px;
}
i{
  color: $color-primary;
  cursor: pointer;
  transition: all .2s ease-in-out;
  font-size: 1.2em;
  flex-grow: 0;
  margin-left: 10px;
  position: relative;
  top: -2px;
}
i:hover{
  color: $color-accent;
}

ul{
  list-style-type: none;
  width: 100%;
  padding-left: 0;
}

li{
  width: 100%;
  text-align: left;
  display: flex;
  // padding: 4px;
  
  align-items: center;
  font-size: .9em;
  transition: all .3s;
}

li:hover{
  //background-color: mix(white, $color-primary, 90);
  background: mix(black, $color-primary, 40);
  cursor: pointer;
}

img{
  width: 50px;
  height: 50px;
}

.listing-favorites__container{
  position: fixed;
  right: -100%;
  bottom: 0;
  color: white;
  background: linear-gradient(mix(black, $color-primary, 50), mix(black, $color-primary, 70));
  border-left: 1px solid mix(white, $color-accent, 10);
  border-top: 1px solid mix(white, $color-accent, 10);
  padding: 5px;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 50px;
  text-align: right;
  z-index: 5;
  transition: all .3s ease-in-out;
  border-top-left-radius: 4px;
  min-width: 300px;
}

.listing-favorites__container h2{
  border-radius: 2px;
  //background: mix(black, $color-primary, 30);
  margin-top: 0;
  background: transparent;
  border-bottom: 2px solid $color-accent;
}

.visible{
  right: 0;
}

.el-button{
  box-shadow: 4px 4px 4px black;
  position: fixed;
  right: 5px;
  bottom: 5px;
  margin: 5;
}


</style>
